import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {
  Card,
  Typography,
  Button,
  Grid,
  TextField
} from '@material-ui/core';
import * as yup from 'yup';
import {Formik} from 'formik';
import {addHelpCategoryApi, editHelpCategoryApi} from 'api/help';
import { BackdropCircular } from 'components';


const MainTabsForm = ({category, setCategory}) => {
  const dispatch = useDispatch();
  const { isLoadingHelpCategories } = useSelector((state) => state.help);

  return (
    <>
      <Card
        className="p-4 m-4"
        elevation={25}
      >
        <Formik
          initialValues={{
            _id: category?._id || '',
            title: category?.title || '',
            path: category?.path || ''
          }}
          onSubmit={async (values) => {
            const category = {
              title: values.title,
              path: values.path
            };

            if (values._id) {
              await editHelpCategoryApi({dispatch, category, categoryId: values._id});
            } else {
              await addHelpCategoryApi({dispatch, category});
            }

            setCategory(null);
          }}
          validationSchema={
            yup.object({
              title: yup
                .string()
                .required('Field is required'),
              path: yup
                .string()
                .required('Field is required')
            })
          }
        >
          {({
            values,
            errors,
            touched,
            handleBlur,
            handleChange,
            handleSubmit
          }) => (
            <form autoComplete="off" className="p-8" onSubmit={handleSubmit}>
              <Grid container spacing={3} className="p-4">
                <Grid item xs={12} sm={12} md={12}>
                  <Typography variant="h5" className="text-brand my-5">Add Main Category</Typography>
                  <TextField
                    required
                    className="w-full"
                    label="Main tab title"
                    name="title"
                    variant="outlined"
                    value={values.title}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.title && Boolean(errors.title)}
                    helperText={touched.title && errors.title}
                  />
                  <TextField
                    required
                    className="w-full mt-10"
                    label="Path"
                    name="path"
                    variant="outlined"
                    value={values.path}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.path && Boolean(errors.path)}
                    helperText={touched.path && errors.path}
                  />
                  <div className="flex items-center justify-end mt-8">
                    <Button
                      variant="contained"
                      onClick={() => setCategory(null)}
                    >
                      Cancel
                    </Button>
                    <Button
                      variant="contained"
                      color="primary"
                      className="mx-10"
                      type="submit"
                    >
                      {values._id ? 'Edit Category' : 'Save Category'}
                    </Button>
                  </div>
                </Grid>
              </Grid>
            </form>
          )}
        </Formik>
      </Card>
      <BackdropCircular loading={isLoadingHelpCategories} />
    </>
  );
};

export default MainTabsForm;
